<!-- Empty state -->
<div
  *ngIf="!refreshing && rowData && rowData.length === 0"
  class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16 tw-px-4">
  <mat-icon
    class="tw-text-gray-400 dark:tw-text-gray-500 tw-text-[72px] tw-w-[72px] tw-h-[72px] tw-mb-4"
    >vpn_key</mat-icon
  >
  <h2 class="tw-text-2xl tw-font-semibold tw-text-gray-800 dark:tw-text-gray-100 tw-mb-2">
    No API Keys Yet
  </h2>
  <p class="tw-text-gray-600 dark:tw-text-gray-400 tw-mb-6 tw-text-center tw-max-w-md">
    Create your first API key to start integrating with our API programmatically.
  </p>
  <button
    mat-raised-button
    color="primary"
    (click)="showCreateDialog()"
    class="tw-px-8 tw-py-3 tw-text-lg">
    Create Your First API Key
  </button>
  <a
    target="_blank"
    href="https://docs.gotlivedata.com/docs/auth#api-keys"
    class="tw-flex tw-items-center tw-gap-1 tw-font-medium tw-text-link-color-dynamic-darker tw-text-sm hover:tw-underline tw-mt-6">
    <mat-icon class="info-icon tw-h-4 tw-w-4">school</mat-icon>
    Learn about using API Keys
  </a>
</div>

<!-- Action buttons and grid (shown when there are API keys) -->
<div *ngIf="!refreshing && rowData && rowData.length > 0">
  <div *ngIf="canAdmin" class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-2 md:tw-gap-4 tw-my-4">
    <a
      target="_blank"
      href="https://docs.gotlivedata.com/docs/auth#api-keys"
      class="tw-flex tw-items-center lg:tw-order-1 tw-gap-1 tw-font-medium tw-text-link-color-dynamic-darker tw-text-sm hover:tw-underline tw-ml-auto">
      <mat-icon class="info-icon tw-h-4 tw-w-4">school</mat-icon>
      Learn about using API Keys
    </a>

    <div class="tw-flex tw-flex-wrap tw-gap-2 md:tw-gap-4 tw-flex-row">
      <button
        *ngIf="!isWorkforceMode"
        mat-raised-button
        [class.spinner]="refreshing"
        [disabled]="refreshing"
        (click)="refreshApiKeys()">
        Refresh
      </button>
      <button mat-raised-button color="primary" (click)="showCreateDialog()">Create API Key</button>
      <button
        mat-flat-button
        color="warn"
        [disabled]="!rowsSelected"
        (click)="removeSelected()"
        class="disabled:tw-border-gray-400 disabled:tw-text-gray-400 disabled:tw-cursor-not-allowed">
        Remove Selected API Keys
      </button>
    </div>
  </div>
  <div class="tw-overflow-x-auto tw-max-w-[1200px]">
    <div class="tw-min-w-[1000px] tw-w-full">
      <ag-grid-angular
        style="width: 100%;"
        [ngClass]="{ 'ag-theme-quartz': !(darkModeService.darkMode$ | async), 'ag-theme-quartz-dark': darkModeService.darkMode$ | async }"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [tooltipShowDelay]="tooltipShowDelay"
        [rowSelection]="{ mode: 'multiRow', headerCheckbox: false, enableClickSelection: false, checkboxes: true, hideDisabledCheckboxes: false }"
        [selectionColumnDef]="{ width: 50, minWidth: 50, maxWidth: 50, suppressHeaderMenuButton: true }"
        enableCellTextSelection="true"
        ensureDomOrder="true"
        domLayout="autoHeight"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>
